import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

// services
import { IPagingService } from '@app/core/interfaces/paging-service.interface';
import { FormsModule } from '@angular/forms';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { AngularSvgIconModule } from 'angular-svg-icon';

/**
 * @deprecated Do not add new instances of this component. Use 'ag1-pagination-v2' instead.
 */
@Component({
  selector: 'ag1-pagination',
  templateUrl: './ag1-pagination.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, Bind, Button, Tooltip, AngularSvgIconModule],
})
export class Ag1PaginationComponent implements OnInit {
  /**
   * Paging service to be used for adding pagination functionality,
   * keeping track of the current page, page size, and refetching data. Variables can also be passed to the service to be used in the query.
   * @param pagingService: IPagingService
   *
   */
  @Input()
  pagingService: IPagingService;

  /**
   * The dropdown options for the page size that the user can select.
   * @param pageSizes: number[]
   */
  @Input()
  pageSizes: number[] = [10, 20, 50, 100];

  /**
   * Optional label for page size 0 (e.g. "All"). When set, the option with value 0 displays this instead of "0".
   */
  @Input()
  zeroPageSizeLabel: string | null = null;

  /**
   * When false, the range is shown as "first - last" only (no " of total"). Use when total count is unknown or expensive.
   */
  @Input()
  showTotal = true;

  /**
   * Event emitter for when the page size is changed.
   * This is used to tell the parent that the page size has changed. You can use this for example to store the page size in local storage.
   */
  @Output()
  pageSizeChanged = new EventEmitter<number>();

  selectedPageSize: number;

  constructor() {}

  ngOnInit(): void {
    if (this.pageSizes.includes(this.pagingService.currentPageSize)) {
      this.selectedPageSize = this.pagingService.currentPageSize;
    }
  }

  nextPage() {
    this.pagingService.goToNextPage();
  }

  previousPage() {
    this.pagingService.goToPrevPage();
  }

  setPageSize() {
    this.pageSizeChanged.emit(Number(this.selectedPageSize));
  }
}
